import axios from 'axios';
import {errorHandler} from "../services/errorHandlers";

const http = axios.create();

/**
 * Interceptor for all request
 * */

http.interceptors.request.use(config => {
    if (config.url.indexOf('paradi-drop-content') === -1 &&
        config.url.indexOf('paradi-drop-revised-transcripts') === -1 &&
        config.url.indexOf('paradi-drop-revised-translations') === -1 &&
        config.url.indexOf('paradi-drop-output') === -1) {
        if (localStorage.accessToken) {
            config.headers.Authorization = `Bearer ${localStorage.accessToken}`;
        }
    }
    return config;
}, error => {
    return Promise.reject(error);
});

/**
 * Interceptor for all response
 * */
http.interceptors.response.use(res => {
    return res;
}, error => {
    const {status} = error.response;
    errorHandler(status);
    return Promise.reject(error)
});

export {http};
